module.exports = __webpack_public_path__ + "media/images/top/top_bg_btm-1170387f651f6a66705588ab50d48b92.gif";